<section class="calendar-shell" aria-label="Calendario de concursos">
  <div class="year-controls" role="group" aria-label="Control de a&ntilde;o">
    <button type="button" (click)="irAnioAnterior()" aria-label="Ir al a&ntilde;o anterior">A&ntilde;o -</button>
    <input
      type="number"
      [ngModel]="anioInput"
      (ngModelChange)="anioInput = $event"
      (blur)="cargarAnioInput()"
      (keyup.enter)="cargarAnioInput()"
      aria-label="Ingresar a&ntilde;o"
    />
    <button type="button" (click)="irAnioSiguiente()" aria-label="Ir al a&ntilde;o siguiente">A&ntilde;o +</button>
  </div>

  <div class="calendar-layout">
    <div class="calendar-head">
      <div class="view-switch">
        <button
          type="button"
          class="view-btn"
          [class.active]="vistaActual === 'mes'"
          (click)="cambiarVista('mes')"
        >
          Mes
        </button>
        <button
          type="button"
          class="view-btn"
          [class.active]="vistaActual === 'anio'"
          (click)="cambiarVista('anio')"
        >
          A&ntilde;o
        </button>
      </div>
      <div class="head-right">
        <span class="head-year">A&ntilde;o {{ anioSeleccionado }}</span>
      </div>
    </div>

    <!-- Filtros locales: limitan los hitos visibles sin modificar la carga del calendario. -->
    <div class="calendar-filters" aria-label="Filtros del calendario">
      <label>
        <span>Estado</span>
        <select [(ngModel)]="estadoSeleccionado" (change)="aplicarFiltros()">
          <option *ngFor="let estado of estadosDisponibles" [ngValue]="estado">{{ etiquetaEstado(estado) }}</option>
        </select>
      </label>

      <label>
        <span>Subdirecci&oacute;n</span>
        <select [(ngModel)]="subdireccionSeleccionada" (change)="aplicarFiltros()">
          <option value="Todas">Todas</option>
          <option *ngFor="let subdireccion of subdireccionesDisponibles" [value]="subdireccion">{{ subdireccion }}</option>
        </select>
      </label>

      <button type="button" class="clear-filters-btn" (click)="limpiarFiltros()">Limpiar filtros</button>
    </div>

    <ng-container *ngIf="vistaActual === 'mes'; else anioView">
      <div class="month-strip" role="tablist" aria-label="Meses del a&ntilde;o">
        <button
          type="button"
          class="month-pill"
          *ngFor="let nombreMes of nombresMeses; let i = index"
          [class.active]="i === mesSeleccionado"
          (click)="seleccionarMes(i)"
        >
          {{ nombreMes }}
        </button>
      </div>

      <div class="weekday-row">
        <span class="weekday" *ngFor="let dia of diasSemana">{{ dia }}</span>
      </div>

      <div class="month-grid">
        <ng-container *ngFor="let semana of semanasMes">
          <article class="day-cell" *ngFor="let dia of semana" [class.outside]="!dia.esMesActual">
            <span class="day-number">{{ dia.dia }}</span>
            <ul class="hitos-list">
              <!-- Cada hito mostrado ya paso por los filtros activos del componente. -->
              <li class="hito-item" *ngFor="let hito of dia.hitos" [title]="hito.subdireccion + ' - ' + etiquetaEstado(hito.estado)">
                {{ hito.nombre }}
              </li>
            </ul>
          </article>
        </ng-container>
      </div>
    </ng-container>

    <ng-template #anioView>
      <div class="months" *ngIf="calendario as cal">
        <div class="month-row" *ngFor="let mes of cal.meses">
          <div class="month-name">{{ mes.nombreMes }}</div>
          <div class="month-track"></div>
        </div>
      </div>
    </ng-template>
  </div>
</section>
